import { render, staticRenderFns } from "./InsuredFormContact.vue?vue&type=template&id=6b372b66&scoped=true&"
import script from "./InsuredFormContact.vue?vue&type=script&lang=ts&"
export * from "./InsuredFormContact.vue?vue&type=script&lang=ts&"
import style0 from "./InsuredFormContact.vue?vue&type=style&index=0&id=6b372b66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b372b66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
